import React, {
    useEffect,
    useRef,
    useState
} from "react";
import {
    Form,
    useNavigate
} from 'react-router-dom';
import Ajax from "../inc/js/Ajax";
import {
    HelmetWrapper
} from "../inc/js/Helper"
import {
    PlusCircle_8_Blue,
    Trash_8_Red
} from "../inc/images/svgs";
import {
    Button,
    Divider,
    Input,
    Spacer,
    Table,
    TableHeader,
    TableColumn,
    TableBody,
    TableRow,
    TableCell,
} from "@nextui-org/react";
import swal from "sweetalert2";

export default function JudgeForm({clientInformation}) {  
    const navigate = useNavigate();
    const [formDetails, setFormDetails] = useState({});
    const [formDetailUpdates, setFormDetailUpdates] = useState({});    
    const [formData, setFormData] = useState({});
    const [formName, setFormName] = useState();
    const [isBasicForm, setIsBasicForm] = useState(true);
    
    const [formChanges, setFormChanges] = useState([]);
    const [formUpdated, setFormUpdated] = useState(false);
    const [formAdditions, setFormAdditions] = useState([]);
    
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [isHovered, setIsHovered] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 640);

    useEffect(() => {
        if (clientInformation.userInformation.loggedIn === false) {
            navigate("/Login");
        } else {
            const queryParams = new URLSearchParams(window.location.search);
            const param = queryParams.get("form") || localStorage.getItem("form");
            
            if (!param) {
                swal.fire({
                    title: "Whoopsie Daisy",
                    text: "Missing Judge Form Id, please try again.",
                    icon: "error",
                    didClose:(() => {
                        navigate("/Forms");
                    })
                })
            } else {
                if (window.history.replaceState) {
                    localStorage.setItem("form", param);
                    window.history.replaceState(null, null, window.location.pathname);
                }

                Ajax.request({
                    url:"/JudgeAutos/readForm",
                    jsonData: {
                        form: "judgeforms",
                        formId: param
                    },
                    success:function(reply) {
                        setFormDetails(reply.data.formDetails);
                        setFormData(reply.data.formData);
                        setFormName(reply.data.formDetails.formName);
                        setIsBasicForm(reply.data.formDetails.type !== "custom");
                    }
                });
            }
        }
    }, [clientInformation]);

    useEffect(() => {
        const handleResize = () => {
            const newWidth = window.innerWidth;
            const isNowMobile = newWidth < 640;
    
            if (Math.abs(newWidth - screenWidth) > 100) {
                setScreenWidth(newWidth);
                setIsMobile(isNowMobile);
            }
        };
    
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [screenWidth]);

    const updateForm = () => {
        return new Promise((resolve, reject) => {
            const preppedFormChanges = Object.entries(formChanges).map(([key, change]) => ({
                ...formData[key],
                ...change
            }));
    
            const preppedInfoUpdates = Object.keys(formDetailUpdates).length > 0 && [{
                formName: formDetailUpdates.formName || formDetails.formName,
                formDescription: formDetailUpdates.formDescription || formDetails.formDescription
            }]
    
            Ajax.request({
                url:"/JudgeAutos/updateForm",
                jsonData: {
                    judgeFormId: formDetails["judgeFormId"],
                    formType: "judge",
                    formAdditions: formAdditions,
                    formChanges: preppedFormChanges,
                    formInfoUpdates: preppedInfoUpdates
                },
                success: function(reply) {
                    swal.fire({
                        title: `${reply.data}`,
                        text: `Changes saved to ${formName}`,
                        icon: "success",
                        timer: 3000,
                        didClose: () => {
                            window.location.href = `/JudgeForm?judgeFormId=${formDetails["judgeFormId"]}`;
                        }
                    });
                    resolve(reply);
                },
                error: function(error) {
                    reject(error);
                }
            });
        });
    }

    const deleteFormDataEntry = async (judgeFormDataId) => {
        if (formUpdated) {
            try {
                await updateForm();
            } catch (error) {
                swal.fire({
                    title: "Error updating form",
                    text: error,
                    icon: "error",
                    didClose: () => {
                        window.location.href = `/JudgeForm?judgeFormId=${formDetails["judgeFormId"]}`;
                    }
                });
            }
        }
        
        Ajax.request({
            url:"/JudgeAutos/deleteFormDataEntry",
            jsonData: {
                formDataId: judgeFormDataId,
                formType: "judge"
            },
            success: function(reply) {
                swal.fire({
                    title: reply.data,
                    text: `Attribute deleted from ${formName}`,
                    icon: "success",
                    didClose: () => {
                        window.location.href = `/JudgeForm?judgeFormId=${formDetails["judgeFormId"]}`;
                    }
                });
            }
        });
    }

    const addRow = () => {
        setFormAdditions((prev) => ([
            ...prev,
            {
                attribute: '',
                attributeDescription: '',
                maxScore: '',
                sequence: ''
            }
        ]));
    }

    const handleUpdateNewRow = (index, id, value) => {
        setFormAdditions((prev) =>
            prev.map((row, rowIndex) =>
                rowIndex === index ? { ...row, [id]: value } : row
            )
        );
        setFormUpdated(true);
    };

    const deleteFormEntryAddition = (indexToRemove) => {
        setFormAdditions((prevAdditions) => 
            prevAdditions.filter((_, index) => index !== indexToRemove)
        );
    };

    const handleFormChanges = (key, id, value) => {
        setFormData((prev) => ({
            ...prev,
            [key]: {
                ...prev[key],
                [id]: value
            }
        }))

        setFormChanges((prev) => ({
            ...prev,
            [key]: {
                ...prev[key],
                [id]: value
            }
        }))

        setFormUpdated(true);
    };

    const handleFormInfoUpdates = (key, value) => {
        setFormUpdated(true);

        setFormDetails((prev) => ({
            ...prev,
            [key]: value
        }));

        setFormDetailUpdates((prev) => ({
            ...prev,
            [key]: value
        }));
    }

    const handleListHover = (index) => {
        setIsHovered(index);
    }

    const handleListUnhover = () => {
        setIsHovered(false);
    }

    // WORK AROUND FOR NEXTUI ISSUE 1968
    const dummyKeyboardDelegate = Object.fromEntries(
        [
          "getKeyBelow",
          "getKeyAbove",
          "getKeyLeftOf",
          "getKeyRightOf",
          "getKeyPageBelow",
          "getKeyPageAbove",
          "getFirstKey",
          "getLastKey",
          // HAVE TO ignore this one
          // "getKeyForSearch"
        ].map((name) => [name, () => null]),
      );

    return(
        <>
            <HelmetWrapper
                title="JudgeAutos - Judge Form"
                description="Create and manage judge forms for your car, truck, and bike shows with JudgeAutos for efficient scoring and event management."
                url="JudgeForm"
            />
    
            <div className="flex-col text-center mx-auto sm:w-2/3">
                {formDetails && (
                    <div>
                        <h1 className="text-3xl">{formName}</h1>
                    </div>
                )}
                <Spacer y={10} />
                {formDetails && (
                    <div>
                        <div>
                            <Form className="grid grid-cols-2 gap-2 place-content-center">
                                <Input
                                    isReadOnly={isBasicForm}
                                    key="formName"
                                    id="formName"
                                    label="Name"
                                    value={formDetails.formName}
                                    onChange={(e) => handleFormInfoUpdates(e.target.id, e.target.value)}
                                    variant="bordered"
                                    classNames={{input: "text-[16px]"}}
                                />
                                <Input
                                    isReadOnly={isBasicForm}
                                    key="formDescription"
                                    id="formDescription"
                                    label="Description"
                                    value={formDetails.formDescription}
                                    onChange={(e) => handleFormInfoUpdates(e.target.id, e.target.value)}
                                    variant="bordered"
                                    classNames={{input: "text-[16px]"}}
                                />
                                <Input
                                    isReadOnly
                                    key="formType"
                                    id="formType"
                                    label="Type"
                                    value={`${formDetails.type ? formDetails.type.charAt(0).toUpperCase() + formDetails.type.slice(1) : ''} Judge Form`}
                                    variant="flat"
                                    classNames={{input: "text-[16px]"}}
                                />
                                <Input
                                    isReadOnly
                                    key="dateCreated"
                                    id="dateCreated"
                                    label="Date Created"
                                    value={new Date(formDetails.dateCreated).toLocaleDateString("en-US")}
                                    variant="flat"
                                    classNames={{input: "text-[16px]"}}
                                />
                            </Form>
                        </div>
                        <Spacer y={3} />
                        <div>
                            <Button
                                className={isBasicForm && "hidden"}
                                onPress={() => {
                                    if (formUpdated) {
                                        updateForm();
                                    } else {
                                        swal.fire({
                                            title: "No changes made",
                                            text: "Please make your changes before saving",
                                            icon: "error",
                                            timer: 1500
                                        })
                                    }
                                }}
                                color="primary"
                            >
                                Save
                            </Button>
                        </div>
                    </div>
                )}

                <Spacer y={5} />
                <Divider />
                <Spacer y={5} />
                
                <Table
                    isStriped
                    bottomContent={
                        !isBasicForm && (
                            <div className="flex justify-center">
                                <Button
                                    isIconOnly
                                    variant="light"
                                    size="sm"
                                    onPress={addRow}
                                >
                                    <PlusCircle_8_Blue />
                                </Button>
                            </div>
                        )
                    }
                    keyboardDelegate={dummyKeyboardDelegate}
                    aria-label="Event registrations"
                >
                    <TableHeader>
                        <TableColumn className="table-cell text-center">Attribute</TableColumn>
                        <TableColumn className="table-cell text-center">Description</TableColumn>
                        <TableColumn className="table-cell text-center">Max Score</TableColumn>
                        <TableColumn className="table-cell text-center">Form Order</TableColumn>
                    </TableHeader>
                    <TableBody>
                        {Object.keys(formData).length > 0 && (
                            Object.entries(formData).map(([key, value]) => (
                                <TableRow
                                    isReadOnly = {isBasicForm}
                                    key={key}
                                    onChange={(e) => handleFormChanges(key, e.target.id, e.target.value)}
                                    onMouseEnter={() => handleListHover(key)}
                                    onMouseLeave={handleListUnhover}
                                >
                                    <TableCell key={`${key}-attribute-cell`} >
                                        <Input
                                            isReadOnly={isBasicForm}
                                            key={`${key}-attribute`}
                                            id="attribute"
                                            type="text"
                                            color="primary"
                                            variant="underlined"
                                            value={formData[key]["attribute"]}
                                            classNames={{input: "text-center bg-transparent text-[16px]", inputWrapper: ["border-0", "shadow-none"]}}
                                            
                                        />
                                    </TableCell>
                                    <TableCell key={`${key}-attributeDescription-cell`} >
                                        <Input
                                            isReadOnly={isBasicForm}
                                            key={`${key}-attributeDescription`}
                                            id="attributeDescription"
                                            type="text"
                                            color="primary"
                                            variant="underlined"
                                            value={formData[key]["attributeDescription"]}
                                            classNames={{input: "text-center bg-transparent text-[16px]", inputWrapper: ["border-0", "shadow-none"]}}
                                        />
                                    </TableCell>
                                    <TableCell key={`${key}-maxScore-cell`} >
                                        <Input
                                            isReadOnly={isBasicForm}
                                            key={`${key}-maxScore`}
                                            id="maxScore"
                                            type="text"
                                            color="primary"
                                            variant="underlined"
                                            value={formData[key]["maxScore"]}
                                            classNames={{input: "text-center bg-transparent text-[16px]", inputWrapper: ["border-0", "shadow-none"]}}
                                        />
                                    </TableCell>
                                    <TableCell key={`${key}-sequence-cell`} >
                                        <Input
                                            isReadOnly={isBasicForm}
                                            key={`${key}-sequence`}
                                            id="sequence"
                                            type="tel"
                                            color="primary"
                                            variant="underlined"
                                            value={formData[key]["sequence"]}
                                            classNames={{input: "text-center bg-transparent text-[16px]", inputWrapper: ["border-0", "shadow-none"]}}
                                            endContent={
                                                !isBasicForm && (
                                                    <div
                                                        className={`
                                                            transition-opacity
                                                            duration-200
                                                            ${
                                                                isHovered === key || isMobile ?
                                                                'opacity-100' :
                                                                'opacity-0'
                                                            }
                                                        `}>
                                                        <Button isIconOnly size="sm" onPress={() => deleteFormDataEntry(formData[key]["judgeFormDataId"])}>
                                                            <Trash_8_Red />
                                                        </Button>
                                                    </div>
                                                )
                                            }
                                        />
                                    </TableCell>
                                </TableRow>
                            ))
                        )}
                        {!isBasicForm &&
                            Object.keys(formAdditions).map((row, index) => (
                                <TableRow
                                    onMouseEnter={() => handleListHover(index)}
                                    onMouseLeave={handleListUnhover}
                                >
                                    <TableCell key={`attribute${index}`}>
                                        <Input
                                            isRequired
                                            id="attribute"
                                            placeholder="Attribute"
                                            type="text"
                                            color="primary"
                                            variant="underlined"
                                            value={formAdditions[index].attribute}
                                            onChange={(event) => handleUpdateNewRow(index, event.target.id, event.target.value)}
                                            classNames={{ input: "text-center bg-transparent text-[16px]", inputWrapper: ["border-0", "shadow-none"] }}
                                        />
                                    </TableCell>
                                    <TableCell key={`description${index}`}>
                                        <Input
                                            id="attributeDescription"
                                            placeholder="Description"
                                            type="text"
                                            color="primary"
                                            variant="underlined"
                                            value={formAdditions[index].attributeDescription}
                                            onChange={(event) => handleUpdateNewRow(index, event.target.id, event.target.value)}
                                            classNames={{ input: "text-center bg-transparent text-[16px]", inputWrapper: ["border-0", "shadow-none"] }}
                                        />
                                    </TableCell>
                                    <TableCell key={`maxScore${index}`}>
                                        <Input
                                            isRequired
                                            id="maxScore"
                                            placeholder="Max"
                                            type="text"
                                            color="primary"
                                            variant="underlined"
                                            value={formAdditions[index].maxScore}
                                            onChange={(event) => handleUpdateNewRow(index, event.target.id, event.target.value)}
                                            classNames={{ input: "text-center bg-transparent text-[16px]", inputWrapper: ["border-0", "shadow-none"] }}
                                        />
                                    </TableCell>
                                    <TableCell key={`sequence${index}`}>
                                        <Input
                                            isRequired
                                            id="sequence"
                                            placeholder="Order"
                                            type="tel"
                                            color="primary"
                                            variant="underlined"
                                            value={formAdditions[index].sequence}
                                            onChange={(event) => handleUpdateNewRow(index, event.target.id, event.target.value)}
                                            classNames={{ input: "text-center bg-transparent text-[16px]", inputWrapper: ["border-0", "shadow-none"] }}
                                            endContent={ 
                                                <div
                                                    className={`
                                                        transition-opacity
                                                        duration-200
                                                        ${
                                                            isHovered === index || isMobile ?
                                                            'opacity-100' :
                                                            'opacity-0'
                                                        }
                                                    `}>
                                                    <Button isIconOnly size="sm" onPress={() => deleteFormEntryAddition(index)}>
                                                        <Trash_8_Red />
                                                    </Button>
                                                </div>
                                            }
                                        />
                                    </TableCell>
                                </TableRow>
                            ))
                        }
                    </TableBody>
                </Table>
                <Spacer y={4} />
                <div>
                    <Button
                        className={isBasicForm && "hidden"}
                        onPress={() => {
                            if (formUpdated) {
                                updateForm();
                            } else {
                                swal.fire({
                                    title: "No changes made",
                                    text: "Please make your changes before saving",
                                    icon: "error",
                                    timer: 1500
                                })
                            }
                        }}
                        color="primary"
                    >
                        Save
                    </Button>
                </div>
            </div>
        </>
    );
}